@if ($isOnlyFeature()) {
<header class="feature-header">
  <h3 [innerHtml]="$content().name"></h3>
</header>
} @if (allFaqCategories.length > 2) {
<div class="control" [formGroup]="manager">
  @for (category of allFaqCategories; track category; let categoryIdx = $index) {
  <div class="choice-item">
    <input
      formControlName="category"
      name="category"
      type="radio"
      class="choice__input ph-no-capture"
      [value]="category"
      [id]="'category-' + categoryIdx"
    />
    <label class="choice__label" [for]="'category-' + categoryIdx">{{ category }}</label>
  </div>
  }
</div>
} @for (faqPair of visibleFaqPairs; track faqPair; let faqPairIdx = $index) {
<details (toggle)="trackFaqItemClick( $event, faqPair.q )">
  <summary>
    <span>{{ faqPair.q }}</span>
  </summary>
  <div [innerHtml]="parseStrapiTextLinks(faqPair.a) | safeHtml"></div>
</details>
}
